<template>
  <base-modal-center
    :isFooter="true"
    ref="shareWedsiteUrlModal"
    title="Compartilhe seu site"
  >
    <template #btn-close-icon>
      <i class="icon">
        <base-icon name="painel/close-icon" />
      </i>
    </template>
    <div class="modal-share-wedsite has-text-centered">
      <h6 class="c-base-modal__title">Compartilhe seu site</h6>
      <div class="c-base-modal__intro">
        O que acha de
        <strong class="has-text-primary"
          >compartilhar seu site com um ou vários convidados de uma vez?</strong
        >
        <br />
        É só personalizar a mensagem abaixo e enviar ;)
      </div>
      <div class="control" style="margin-bottom: 15px">
        <textarea
          v-model="message"
          class="textarea"
          maxlength="650"
          rows="10"
        ></textarea>
        <p class="has-text-right">
          <small
            :class="{ 'c-base-modal--text-primary': message.length >= 650 }"
            >{{ message.length }} / 650</small
          >
        </p>
      </div>
      <a
        class="c-base-modal__button c-base-modal__button--fullsize c-base-modal__button--whatsapp"
        @click="close"
        :href="whatsAppLink"
        target="_blank"
        title="Compartilhar via WhatsApp"
        v-if="modalOpened"
      >
        <i class="fa fa-whatsapp" style="margin-right: 6px"></i>
        Compartilhar via WhatsApp
      </a>
    </div>
  </base-modal-center>
</template>

<script>
import isMobileBrowser from '@/plugins/detect-mobile-browser'
import BaseModalCenter from '@/components/BaseModalCenter.vue'

export default {
  components: {
    BaseModalCenter,
  },

  data() {
    return {
      modalOpened: false,
      message: `Olá, está chegando o momento mais esperado do ano! O nosso casamento ❤️ Estamos muito felizes e contamos com a sua presença no nosso grande dia!\n\nPara facilitar na organização do nosso casamento, criamos um site onde compartilhamos com você todos os detalhes do nosso evento.\n\nÉ muito importante que você confirme a sua presença. Para isto, basta clicar no menu “Confirme sua Presença” e preencher os dados necessários.\n\nPara nos presentear, você pode escolher qualquer item da nossa Lista de Presentes 😊\n\nAguardamos você no nosso grande dia!`,
    }
  },

  computed: {
    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    whatsAppLink() {
      let linkToShare = `Clique no link abaixo e acesse nosso site:\n${this.wedSiteInfo.shared_menu.wedsite_url_for_guests}`

      let linkWP = isMobileBrowser()
        ? 'whatsapp://'
        : 'https://web.whatsapp.com/'
      linkWP += 'send?text='

      if (this.message.length) {
        return (
          linkWP +
          window.encodeURIComponent(`${this.message}\n\n${linkToShare}`)
        )
      }
      return linkWP + window.encodeURIComponent(linkToShare)
    },
  },

  methods: {
    open() {
      this.$refs.shareWedsiteUrlModal.open()
      this.modalOpened = true
    },

    close() {
      this.$refs.shareWedsiteUrlModal.close()
      this.modalOpened = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
